import React, { useState } from "react";
import "../roles/RolesPage.css";

const modules = [
  "Client",
  "Sub Vendor",
  "Recruitment",
  "Recruitment Pipeline",
  "Candidate",
  "Onboarding",
  "Employee",
  "Attendance",
  "Payroll",
  "Leaves",
  "Invoice",
  "Configuration",
];

const permissions = ["Access", "Add", "View", "Edit", "Delete"];

export default function RolesPage() {
  const [selectedRole, setSelectedRole] = useState("");
  const [roleMatrix, setRoleMatrix] = useState(
    modules.reduce((acc, mod) => {
      acc[mod] = permissions.reduce((pAcc, perm) => {
        pAcc[perm] = false;
        return pAcc;
      }, {});
      return acc;
    }, {})
  );

  const handleCheckboxChange = (module, permission) => {
    setRoleMatrix((prev) => ({
      ...prev,
      [module]: {
        ...prev[module],
        [permission]: !prev[module][permission],
      },
    }));
  };

  const handleSave = () => {
    console.log("Saving Role Config:", {
      role: selectedRole,
      permissions: roleMatrix,
    });
    alert("Role configuration saved! (Check console)");
  };

  return (
    <div className='roles-container'>
      <header className='roles-header'>
        <h2>Roles list</h2>
        <p className='subtitle'>Roles Information</p>
      </header>

      <div className='role-select'>
        <label>User Role:</label>
        <select
          value={selectedRole}
          onChange={(e) => setSelectedRole(e.target.value)}
        >
          <option value=''>Select Role</option>
          <option value='Admin'>Admin</option>
          <option value='Manager'>Manager</option>
          <option value='HR'>HR</option>
        </select>
      </div>

      <div className='roles-table-wrapper'>
        <table className='roles-table'>
          <thead>
            <tr>
              <th>Module</th>
              {permissions.map((perm) => (
                <th key={perm}>{perm}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {modules.map((mod) => (
              <tr key={mod}>
                <td className='module-name'>{mod}</td>
                {permissions.map((perm) => (
                  <td key={perm}>
                    <input
                      type='checkbox'
                      checked={roleMatrix[mod][perm]}
                      onChange={() => handleCheckboxChange(mod, perm)}
                    />
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <div className='actions'>
        <button
          className='save-btn'
          onClick={handleSave}
          disabled={!selectedRole}
        >
          Save Role Permissions
        </button>
      </div>
    </div>
  );
}
